
/**
 * Module dependencies.
 */

import {
  REQUEST_METADATA_OWNERS,
  RECEIVE_METADATA_OWNERS,
  FETCH_METADATA_OWNERS_ERROR,
  REMOVE_METADATA_OWNER_ERROR,
  ADD_METADATA_OWNER_ERROR,
  INVALIDATE_METADATA_OWNERS
} from '../actions'

/**
 * Current user reducer.
 */

export default function metadatasOwnersBySlug (state = initialState(), action) {
  const { type, payload } = action
  switch (type) {
    case REQUEST_METADATA_OWNERS:
      return {
        ...state,
        [payload.metadataType]: {
          ...[payload.metadataType],
          [payload.slug]: {
            isRequesting: true,
            didInvalidate: false,
            didRequestFail: false,
            data: []
          }
        }
      }
    case RECEIVE_METADATA_OWNERS:
      return {
        ...state,
        [payload.metadataType]: {
          ...[payload.metadataType],
          [payload.slug]: {
            isRequesting: false,
            didInvalidate: false,
            didRequestFail: false,
            data: payload.data
          }
        }
      }
    case FETCH_METADATA_OWNERS_ERROR:
      return {
        ...state,
        [payload.metadataType]: {
          ...[payload.metadataType],
          [payload.slug]: {
            isRequesting: false,
            didInvalidate: false,
            didRequestFail: true,
            data: []
          }
        }
      }

    case INVALIDATE_METADATA_OWNERS:
      return {
        ...state,
        [payload.metadataType]: {
          ...[payload.metadataType],
          [payload.slug]: {
            isRequesting: false,
            didInvalidate: true,
            didRequestFail: false,
            data: state[payload.metadataType][payload.slug].data || []
          }
        }
      }

    case REMOVE_METADATA_OWNER_ERROR:
      return {
        ...state,
        [payload.metadataType]: {
          ...[payload.metadataType],
          [payload.slug]: {
            isRequesting: false,
            didInvalidate: false,
            didRequestFail: true,
            data: state[payload.metadataType][payload.slug].data || []
          }
        }
      }

    case ADD_METADATA_OWNER_ERROR:
      return {
        ...state,
        [payload.metadataType]: {
          ...[payload.metadataType],
          [payload.slug]: {
            isRequesting: false,
            didInvalidate: false,
            didRequestFail: true,
            data: state[payload.metadataType][payload.slug].data || []
          }
        }
      }

    default:
      return state
  }
}

/**
 * Initial state.
 */

function initialState () {
  const types = [ 'source', 'integration', 'bitool', 'warehouse' ]
  const state = {}
  types.forEach(t => (state[t] = {}))
  return state
}



// WEBPACK FOOTER //
// ./reducers/metadata-owners.js